(
    function (skyward, $, undefined)
    {
        skyward.family = skyward.family || {};

        skyward.family.newFamilyTab = function ()
        {
            var parentBrowse = $(this).parents('#StudentGuardianNameLookupBrowse')[0];
            if (parentBrowse.hasAttribute("data-studentid"))
            {
                skyward.window.loadContent('popout', "Family", "StudentFamily", "StudentProfile", parentBrowse.attributes["data-studentid"].value);
            }
        };

        skyward.family.newSiblingStudentProfileTab = function ()
        {
            var sourceButton = $(this);
            var studentID = sourceButton.data('studentid');
            var schoolYearID = sourceButton.data('schoolyearid');
            var entityID = sourceButton.data('entityid');

            var target = skyward.global.mobileAccess ? 'full' : 'popout'; // 'popout' in mobile opens in a modal
            var data = { StudentID: studentID, SchoolYearID: schoolYearID, EntityID: entityID };

            skyward.window.loadContent(target, "Student", "Student", "SwitchEntityForSiblingProfile", undefined, data);
        };

        var checkForDirtySkylertCredentials = function (event) {
            var field = $(event.target);
            var originalValue = skyward.controls.getOriginalValue(field);
            var value = field.val();
            var fieldDirty = value !== originalValue;

            var isDirty = skyward.changeTracking.isDirty($(".js-triggerSkylertWorkflowHide").not(field).parent());
            setSkylertTestConnectionHidden(isDirty || fieldDirty);

        }

        var setSkylertTestConnectionHidden = function (hasPendingChanges) {
            $(".js-hideOnPendingChanges").each(function () {
                this.style.display = hasPendingChanges ? "none" : "";
            });
        }

        skyward.family.skylertClearNamePhone = function (event) {
            var source = $(event.target).closest('a');
            var textboxID = source.data('id');
            var sequenceNumber = source.data('sequencenumber');
            var districtID = source.data('districtid');

            var selectAllCheckboxes = $(event.target).parents('.browseBody').find('[id ^="SelectAll-NamePhone-JobType-"][id $="-' + sequenceNumber + '"][type="checkbox"]:not(.ui-disabled)');
            var checkboxes = $(event.target).parents('.browseBody').find('[id ^="NamePhone-JobType-"][data-sequencenumber="' + sequenceNumber + '"][data-districtid="' + districtID + '"][type="checkbox"]:not(.ui-disabled)');
            var phoneTextBox = $(event.target).parents('.browseBody').find('#PhoneNumber-' + textboxID);
            var phoneTypeInput = $(event.target).parents('.browseBody').find("[name='PhoneType-" + textboxID + "']");

            skyward.controls.setValue(selectAllCheckboxes, "false", false);
            skyward.controls.setValue(checkboxes, "false", false);
            if (!phoneTextBox.is('[readonly]'))
            {
                skyward.controls.setValue(phoneTextBox, "", false);
            }
            skyward.codeeel.clear(phoneTypeInput.closest(".codeEEL"), true);
        }

        skyward.family.skylertClearNameEmail = function (event) {
            var source = $(event.target).closest('a');
            var textboxID = source.data('id');
            var sequenceNumber = source.data('sequencenumber');
            var districtID = source.data('districtid');

            var selectAllCheckboxes = $(event.target).parents('.browseBody').find('[id ^="SelectAll-NameEmail-JobType-"][id $="-' + sequenceNumber + '"][type="checkbox"]:not(.ui-disabled)');
            var checkboxes = $(event.target).parents('.browseBody').find('[id ^="NameEmail-JobType-"][data-sequencenumber="' + sequenceNumber + '"][data-districtid="' + districtID + '"][type="checkbox"]:not(.ui-disabled)');
            var emailTextBox = $(event.target).parents('.browseBody').find('#EmailAddress-' + textboxID);
            var emailTypeInput = $(event.target).parents('.browseBody').find("[name='EmailType-" + textboxID + "']");

            skyward.controls.setValue(selectAllCheckboxes, "false", false);
            skyward.controls.setValue(checkboxes, "false", false);
            if (!emailTextBox.is('[readonly]'))
            {
                skyward.controls.setValue(emailTextBox, "", false);
            }
            skyward.codeeel.clear(emailTypeInput.closest(".codeEEL"), true);
        }

        skyward.family.skylertClearSchoolMessenger = function (event) {
            var source = $(event.target).closest('a');
            var id = source.data('id');
            var textBox = $(event.target).parents('.browseBody').find('[id ^="SchoolMessenger"][id $="-' + id + '"][type !="checkbox"]');
            var checkboxes = $(event.target).parents('.browseBody').find('[id ^="SchoolMessenger"][id $="-' + id + '"][type="checkbox"]:not(.ui-disabled)');
            skyward.controls.setValue(checkboxes, false, false);
            skyward.controls.setValue(textBox, "", false);
        }

        var familySystemConfigEnableActiveStudentEnrollmentPopup = function (event) {
            var button = $(this);
            var title = 'Setting Information';
            var options =
            {
                anchorTo: button,
                id: "FamilySystemConfigEnableActiveStudentEnrollmentPopup"
            };

            var message = '<span>Enabling this option will allow active Students to be selected from the Existing Students drop down when approving a New Student Enrollment Online Form.<span>';

            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        // Event handlers
        var events =
        {
            "newFamilyTab": skyward.family.newFamilyTab,
            "newSiblingStudentProfileTab": skyward.family.newSiblingStudentProfileTab,
            "skylertClearNamePhone": skyward.family.skylertClearNamePhone,
            "skylertClearNameEmail": skyward.family.skylertClearNameEmail,
            "familySystemConfigEnableActiveStudentEnrollmentPopup": familySystemConfigEnableActiveStudentEnrollmentPopup
        };
        skyward.events.registerEvents("family", events);

        var init = function (selector)
        {
            var studentGuardianAddWorkflowRepeater = $(selector).find("#StudentGuardianAddWorkflowRepeater");
            if (studentGuardianAddWorkflowRepeater.length !== 0)
            {
                studentGuardianAddWorkflowRepeater.trigger("onload");
            }

            var skylertConnectionFields = $(selector).find(".js-triggerSkylertWorkflowHide");
            if (skylertConnectionFields.length !== 0) {
                skylertConnectionFields.off('keyup').on('keyup', checkForDirtySkylertCredentials);
            }

        }

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
